export const FontSizes = {
  "-3": "1rem",
  "-2": "1.2rem",
  "-1": "1.4rem",
  "0": "1.6rem",
  "1": "1.8rem",
  "2": "2.0rem",
  "3": "2.4rem",
  "4": "3.0rem",
  "5": "3.6rem",
  "6": "4.8rem",
  "7": "6.0rem",
  "8": "7.2rem",
  "9": "9.0rem",
  "10": "11.2rem",
};
